import React, { Component } from 'react';
import File from './File';
import Folder from './Folder';
import _ from 'lodash';
import Breadcrumb from './Breadcrumb';
import AddFolder from './AddFolder';
import Upload from './Upload';
import UploadInfoSeries from './UploadInfoSeries';

export default class Table extends Component {
  constructor(props) {
    super(props);

    const files = props.files ? props.files : [];
    const infoSeriesFiles = props.infoSeriesFiles ? props.infoSeriesFiles : [];
    this.state = {
      files: this.cleanfiles(files),
      infoSeriesFiles: infoSeriesFiles
    };
  }

  componentDidMount() {
    const files = this.state.files;
    if (files.length === 0) {
      files.push({
        name: 'No files exist',
        type: 'none'
      });
    }

    files.unshift(
      {
        type: 'addFolder'
      },
      {
        type: 'upload'
      },
      {
        type: 'uploadInfoSeries'
      }
    );

    this.setState({ files: files });
  }

  cleanfiles(files) {
    return _.filter(
      files.map(file => {
        if (file.name) {
          if (file.type === 'folder') {
            file.name = _.startCase(file.name);
          }

          return file;
        }

        return null;
      })
    );
  }

  renderBreadcrumbs() {
    return (
      <Breadcrumb
        breadcrumbs={this.props.breadcrumbs}
        onClick={link => this.props.onBreadCrumbClick(link)}
      />
    );
  }

  renderRows(files) {
    let i = 0;
    return (
      <tbody>
        {_.filter(
          files.map(obj => {
            i++;
            switch (obj.type) {
              case 'folder':
                return (
                  <Folder
                    file={obj}
                    key={obj.path}
                    onClick={path => this.props.onClick(path)}
                    onDelete={path => this.props.onDelete(path)}
                    onRename={(from, to) => this.props.onRename(from, to)}
                    onCopy={(from, to, currentDir) =>
                      this.props.onCopy(from, to, currentDir)
                    }
                    class={i % 2 === 0 ? 'odd' : 'even'}
                  />
                );
              case 'file':
                return (
                  <File
                    file={obj}
                    key={obj.path}
                    onClick={path => this.props.onClick(path)}
                    onDelete={path => this.props.onDelete(path)}
                    onRename={(from, to) => this.props.onRename(from, to)}
                    onCopy={(from, to, currentDir) =>
                      this.props.onCopy(from, to, currentDir)
                    }
                    class={i % 2 === 0 ? 'odd' : 'even'}
                    isCustomerView={this.props.isCustomerView}
                  />
                );
              case 'none':
                return (
                  <tr key="none">
                    <td>{obj.name}</td>
                  </tr>
                );
              case 'addFolder':
                return (
                  <AddFolder
                    handleChangeFolder={path =>
                      this.props.handleChangeFolder(path)
                    }
                    key="addFolder"
                    hide={this.props.hideAddFolder}
                    handleCancel={() => this.props.addFodlerCancel()}
                  />
                );
              case 'upload':
                return (
                  <Upload
                    key="upload"
                    hide={this.props.hideUpload}
                    handleCancel={() => this.props.uploadCancel()}
                    handleUpload={file => this.props.handleUpload(file)}
                  />
                );
              case 'uploadInfoSeries':
                return (
                  <UploadInfoSeries
                    key="uploadInfoSeries"
                    hide={this.props.hideUploadInfoSeries}
                    files = {this.state.infoSeriesFiles}
                    handleCancel={() => this.props.uploadInfoSeriesCancel()}
                    handleUploadInfoSeries={files => this.props.handleUploadInfoSeries(files)}
                  />
                );
              default:
                return '';
            }
          })
        )}
      </tbody>
    );
  }

  render() {
    return (
      <table cellSpacing="0" cellPadding="0">
        <thead>
          <tr className="small">
            <th colSpan="2">{this.renderBreadcrumbs()}</th>
          </tr>
        </thead>
        {this.renderRows(this.state.files)}
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table.js